/**
 * PWA Manifest Manager
 * 
 * Gestiona dinámicamente el manifest de la PWA según la ruta actual.
 * Permite tener manifests separados para admin y technician.
 */

export type ManifestType = 'admin' | 'technician';

/**
 * Detecta qué tipo de manifest debe cargarse basado en la ruta actual
 */
export function detectManifestType(): ManifestType {
  const path = window.location.pathname;
  
  if (path.startsWith('/admin')) {
    return 'admin';
  }
  
  if (path.startsWith('/technician')) {
    return 'technician';
  }
  
  // Default: si estamos en root o login, no cambiamos el manifest
  // Se mantendrá el que esté configurado por defecto
  return 'admin'; // Por defecto admin para casos ambiguos
}

/**
 * Actualiza el link del manifest en el DOM
 */
export function updateManifestLink(type: ManifestType): void {
  const manifestLink = document.querySelector('link[rel="manifest"]');
  const manifestPath = `/manifest-${type}.json`;
  
  if (manifestLink) {
    manifestLink.setAttribute('href', manifestPath);
  } else {
    // Si no existe, crear el link
    const link = document.createElement('link');
    link.rel = 'manifest';
    link.href = manifestPath;
    document.head.appendChild(link);
  }
}

/**
 * Inicializa el manifest correcto basado en la ruta
 * Debe llamarse al inicio de la aplicación
 */
export function initializeManifest(): void {
  const type = detectManifestType();
  updateManifestLink(type);
}

/**
 * Hook para React que actualiza el manifest cuando cambia la ruta
 */
export function useManifestSync(): void {
  // Este hook se puede implementar en el futuro si se necesita
  // cambiar el manifest dinámicamente durante la navegación
  // Por ahora, solo se establece al inicio
}
